import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SupplierEdiReportService } from '@shabic/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'shabic-supplier-edi',
  templateUrl: './supplier-edi.component.html',
  styleUrls: ['./supplier-edi.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupplierEdiComponent implements OnInit {
  reports: any[] = [];
  loading = false;
  error: string | null = null;
  pageSize = 10;
  currentPage = 1;
  totalPages = 1;
  totalElements = 0;

  constructor(
    private supplierEdiReportService: SupplierEdiReportService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.fetchReports();
  }

  fetchReports(page: number = 1) {
    this.loading = true;
    this.error = null;
    const params: any = { size: this.pageSize, page: page - 1 };
    this.supplierEdiReportService.getSupplierOrderDailyReports(params).subscribe({
      next: (response: any) => {
        if (response && response.content) {
          this.reports = response.content;
          this.totalPages = response.totalPages || 1;
          this.totalElements = response.totalElements || this.reports.length;
        } else {
          this.reports = [];
          this.totalPages = 1;
          this.totalElements = 0;
        }
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: (err: any) => {
        this.error = 'Failed to load reports';
        this.loading = false;
        this.cdr.markForCheck();
      },
    });
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.fetchReports(page);
    }
  }
} 